




















import { Component, Vue } from 'vue-property-decorator';
import Sidebar from '@/components/Sidebar.vue';
import Canvas from '@/components/canvas/Canvas.vue';
import EditorManager from '@/EditorManager';
import Resizer from '@/components/Resize/Resizer.vue';
import Resizable from '@/components/Resize/Resizable.vue';
import { mapGetters } from 'vuex';
import EditorType from '@/EditorType';
import { Getter } from 'vuex-class';

@Component({
  components: {
    Resizer,
    Resizable,
    Sidebar,
    Canvas,
  },
  computed: mapGetters(['currEditorModel']),
})
export default class Editor extends Vue {
  private manager: EditorManager = EditorManager.getInstance();
  private editorWidth = 75; /* percentage */
  private sidebarWidth = 280; /* pixels */
  @Getter('currEditorType') currEditorType!: EditorType;

  private changeWidth(percentage: number) {
    this.editorWidth = percentage;
  }
}
